import { useEffect } from 'react';
import PageHeader from '@/components/base/PageHeader';

export default function Datenschutz() {
  useEffect(() => {
    document.title = 'Datenschutz | Druckerei Rahmede';
  }, []);

  return (
    <>
      <PageHeader
        label="Rechtliches"
        title="Datenschutzerklärung"
      />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-10">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                1. Verantwortlicher
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-1">
                <p className="font-semibold text-foreground-800">Rahmede GmbH</p>
                <p>Unterm Eichholz 8</p>
                <p>58579 Schalksmühle-Heedfeld</p>
                <p>Deutschland</p>
                <p className="mt-2">E-Mail: info@rahmede-druck.de</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                2. Allgemeine Hinweise
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>
                  Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                </p>
                <p>
                  Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich sowie entsprechend der gesetzlichen Datenschutzvorschriften und dieser Datenschutzerklärung.
                </p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                3. Datenerfassung auf unserer Website
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>
                  <strong className="text-foreground-800">Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                  Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                </p>
                <p>
                  <strong className="text-foreground-800">Wie erfassen wir Ihre Daten?</strong><br />
                  Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen (z. B. über das Kontaktformular). Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst.
                </p>
                <p>
                  <strong className="text-foreground-800">Wofür nutzen wir Ihre Daten?</strong><br />
                  Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Daten, die Sie über das Kontaktformular übermitteln, werden ausschließlich zur Bearbeitung Ihrer Anfrage genutzt.
                </p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                4. Kontaktformular
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
                </p>
                <p>
                  Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Sie können diese Einwilligung jederzeit widerrufen.
                </p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                5. Ihre Rechte
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung oder Löschung dieser Daten.</p>
                <p>Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.</p>
                <p>Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                6. Widerspruchsrecht
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Wenn die Verarbeitung Ihrer personenbezogenen Daten aufgrund von berechtigten Interessen erfolgt, haben Sie das Recht, gegen die Verarbeitung Widerspruch einzulegen, sofern Gründe für den Widerspruch vorliegen, die sich aus Ihrer besonderen Situation ergeben.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                7. SSL- bzw. TLS-Verschlüsselung
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}